export default __webpack_public_path__ + "static/media/spa-image-16.d61503c7.jpg";